import { Component } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import {
  LEVEL_PUBLISHED,
  PARAM_USERS_PATH,
  STATE_PAGES_PUBLISHED,
} from "src/app/admin/constants/constants";
import { Clients } from "src/app/models/clients";
import { AbstractListController } from "src/app/common/abstract-list.component";
import { environment } from "src/environments/environment";
import { Pages } from "src/app/models/pages";
import { Users } from "src/app/models/users";
import { UsersService } from "src/app/services/users.service";

import { DynamicFiltersComponent } from "src/app/components/dynamic-filters/dynamic-filters.component";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DatePipe } from "@angular/common";
import { DrawerModule } from "primeng/drawer";
import { SharedModule } from "primeng/api";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { NgxPaginationModule } from "ngx-pagination";
import { Ripple } from "primeng/ripple";
import { RouterLink } from "@angular/router";
import { TableModule } from "primeng/table";
import { TagModule } from "primeng/tag";
import { ToastModule } from "primeng/toast";
import { TopNavComponent } from "../../../top-nav/top-nav.component";

@Component({
    selector: "app-manage-users",
    templateUrl: "./manage-users.component.html",
    imports: [DynamicFiltersComponent, ButtonModule, CardModule, ConfirmDialogModule, DatePipe, DrawerModule, SharedModule, FormsModule, InputTextModule, NgxPaginationModule, Ripple, RouterLink, TableModule, TagModule, ToastModule, TopNavComponent]
})
export class ManageUsersComponent extends AbstractListController<Users, any> {
  title = "Utenti";
  imageUrl: string;
  pages: Users[];
  pageUrl = PARAM_USERS_PATH;

  constructor(
    protected usersService: UsersService,
    protected confirmationService: ConfirmationService,
    router: Router,
    route: ActivatedRoute
  ) {
    super(usersService, confirmationService, router, route, PARAM_USERS_PATH);
    this.imageUrl = environment.news_image_url;

    this.cols.set([
      { field: "page_title", header: "Titolo" },
      { field: "page_template", header: "Tipo" },
      { field: "is_active", header: "Attivo" },
      { field: "is_featured", header: "Featured" },
    ])

    this.colsFilter.set([
      { field: "username", header: "Username", type: "string" },
      { field: "email", header: "Email", type: "string" },
    ])


    this.setupDynamicFilters();
  }



}
